export class URIConf {
    static baseUrl = 'https://hulkcore.watzap.id';
}
